import { ComponentConstructor, Label, Panel, PanelProps } from "@mcleod/components";
import { AbstractComponentDemoExamples } from "./examples/AbstractComponentDemoExamples";
import { Collection } from "@mcleod/core";

export abstract class AbstractSectionPanel extends Panel {
    constructor(title: string, defs: Collection<any>, examples: AbstractComponentDemoExamples,
        componentClassRef: ComponentConstructor, componentName: string, props?: Partial<PanelProps>) {
        super({ fillRow: true, ...props });
        this.addTitleLabel(title);
        this.addSectionHeadingLine();
        this.addLines(defs, examples, componentClassRef, componentName);
    }

    private addTitleLabel(title: string) {
        const labelTitle = new Label({
            text: title,
            fontBold: true,
            fontSize: "large",
            color: "primary",
            marginTop: 32
        });
        this.add(labelTitle);
    }

    protected abstract getLineHeaderPanelClass(): ComponentConstructor;
    protected abstract getLinePanelClass(): ComponentConstructor;

    protected addSectionHeadingLine() {
        const headerPanelLineClass = this.getLineHeaderPanelClass();
        const headingLinePanel = new headerPanelLineClass(this);
        this.add(headingLinePanel);
    }
    
    protected addLines(defs: Collection<any>, examples: AbstractComponentDemoExamples,
        componentClassRef: ComponentConstructor, componentName: string) {
        const names = Object.keys(defs).sort();
        names.forEach(name => {
            const propDef = defs[name];
            const examplesForProperty = examples?.get(name, componentClassRef, componentName);
            const linePanelClass = this.getLinePanelClass();
            const linePanel = new linePanelClass(name, propDef, examplesForProperty);
            this.add(linePanel);
        });
    }
}
